import React, { useEffect } from "react";
import TagManager from "react-gtm-module";
import { useRouter } from "next/router";

const GoogleTagManager = () => {
  const router = useRouter();
  const GTMIF = process.env.NEXT_PUBLIC_GTM_ID;
  const tagManagerArgs = {
    gtmId: GTMIF,
  };
  useEffect(() => {
    //comented out for qa and dev
    // if (process.env.NODE_ENV === "production") {
    //   TagManager.initialize(tagManagerArgs);
    // }

    return () => {};
  }, []);

  return <React.Fragment />;
};

export default GoogleTagManager;
